import { useTranslate } from "ra-core";

import { Badge } from "@/components/ui/badge";

import type { FinanceChargeStatus } from "../../types";

const VARIANTS: Record<
  FinanceChargeStatus,
  "default" | "secondary" | "destructive" | "outline"
> = {
  pending: "outline",
  sent: "secondary",
  overdue: "destructive",
  paid: "default",
  cancelled: "outline",
};

export const ChargeStatusBadge = ({
  status,
}: {
  status: FinanceChargeStatus;
}) => {
  const translate = useTranslate();
  return (
    <Badge
      variant={VARIANTS[status]}
      className={status === "cancelled" ? "line-through" : undefined}
    >
      {translate(`crm.finance.charges.statuses.${status}`)}
    </Badge>
  );
};
